var _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _g, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyTableIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 64,
    viewBox: "0 0 73 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H64.1667L68 4L72.5 8.5V64H22.5V0Z",
    fill: "#899EA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H64.1667V8.5H72.5V64H22.5V0Z",
    fill: "#2B3031"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 20,
    width: 38,
    height: 4,
    fill: "#899EA2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 28,
    width: 38,
    height: 4,
    fill: "#899EA2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 36,
    width: 38,
    height: 4,
    fill: "#899EA2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 44,
    width: 38,
    height: 4,
    fill: "#899EA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5619 36.5979L19.4753 39.6528L6.18834 54.0105C5.08575 55.202 3.20656 55.2161 2.08622 54.0413L1.36545 53.2855C0.245117 52.1108 0.348267 50.2343 1.59062 49.1895L16.5619 36.5979Z",
    fill: "#8CE1FA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_763_27970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 36,
    width: 20,
    height: 19
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5619 36.5979L19.4753 39.6528L6.18834 54.0105C5.08575 55.202 3.20656 55.2161 2.08622 54.0413L1.36545 53.2855C0.245117 52.1108 0.348267 50.2343 1.59062 49.1895L16.5619 36.5979Z",
    fill: "#D1D5DB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_763_27970)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8895 45.0166C14.9571 44.3266 14.071 43.5474 13.2431 42.6793C12.4153 41.8112 11.679 40.8892 11.034 39.9252L15.33 36.312C15.8739 37.2037 16.5207 38.0513 17.271 38.8381C18.0213 39.6248 18.8373 40.3111 19.7023 40.8966L15.8895 45.0166Z",
    fill: "#334155"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 28.1406,
    y: 10,
    width: 26.7356,
    height: 26.7356,
    rx: 13.3678,
    transform: "rotate(46.3583 28.1406 10)",
    fill: "#FF974B",
    style: {
      mixBlendMode: "color"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.1406,
    y: 10,
    width: 26.7356,
    height: 26.7356,
    rx: 13.3678,
    transform: "rotate(46.3583 28.1406 10)",
    stroke: "#8CE1FA",
    strokeWidth: 4.2214
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTableIllustration);
export default __webpack_public_path__ + "static/media/empty_table_illustration.d7c7f175b29233390a92b1890bbc6a86.svg";
export { ForwardRef as ReactComponent };